import { View } from 'react-native';

import { usePaymentFlowStore } from '../payment';

export default function RemovePointerEventsOnCommit() {
  const { currentState } = usePaymentFlowStore();
  // Block pointer events only during active processing states
  // Only allow pointer events on idle, error
  const processingStates: Array<typeof currentState> = [
    'encrypting',
    'validatingCart',
    'serviceModeCheck',
    'committing',
    'confirming',
    'vaulting',
    'insertRequested',
    'success',
  ];

  const isPlacingOrder = processingStates.includes(currentState);

  return (
    <>
      {isPlacingOrder && (
        <View
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            pointerEvents: 'auto',
            backgroundColor: 'transparent',
          }}
        />
      )}
    </>
  );
}
